// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "a8b2dde9-dirty",
    "hash": "a8b2dde9",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "a8b2dde9-dirty",
    "semverString": null,
    "version": "3.6.4",
    "branch": "(HEAD detached at a8b2dde9)"
};
/* tslint:enable */
